import React from "react";
import { Route } from "react-router-dom";
import { Layout } from "../pages/layout/Layout";
import { SketchResult } from "../pages/users/uploadimage/create_contest/SketchResult";
import { SketchComments } from "../pages/users/uploadimage/create_contest/SketchComments";
import UserProfile from "../pages/profile/UserProfile";
import NotFoundPage from "../pages/error/NotFoundPage";
import ProtectedRoute from "../routes/ProtectedRoute";

import { ContestDetail } from "../pages/contest/ContestDetail";
import RecomendedArtist from "../pages/users/RecomendedArtist";
import ArtistContestRequest from "../pages/contest/ArtistContestRequest";
import ArtistContestEventRequest from "../pages/contest/ArtistContestEventRequest";
import { MyContest } from "../pages/contest/MyContest";
import UserPage from "../pages/users/UserPage";
import { Notifications } from "../pages/notification/Notifications";
import { ContestResult } from "../pages/admin/contests/ContestResult";
import { PricingPlan } from "../pages/pricing/PricingPlan";
import { Checkout } from "../pages/checkout/Checkout";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_test_51Q3JqXAk3rPClgNeNUhwblAMcUHZGovpvDdkpJQfpTiriYMkBw8bC4a0boU4TjU8tWhgkECwPQmw8oCgIvA0yLKE00ZWdMIpNm");



export const UserRoutes = () => {


  return (
    <Route element={<ProtectedRoute />}>
      <Route path="/user" element={<Layout />}>
         <Route index element={<UserPage />} />
        <Route path="connected-event/:eventId" element={<UserPage />} />
        <Route path="my-contests" element={<MyContest />} />
        <Route path="contest-detail/:purpose/:contestId" element={<ContestDetail />}/>
        <Route path="contest-artist-request/:contestId" element={<ArtistContestRequest />}/>
        <Route path="contest-artist-event-request/:contestId" element={<ArtistContestEventRequest />}/>
        <Route path="sketch-result" element={<SketchResult />} />
        <Route path="sketch-comments" element={<SketchComments />} />
        <Route path="recomended-artist" element={<RecomendedArtist />} />
        <Route path="profile/:userId" element={<UserProfile />} />
        <Route path="notifications" element={<Notifications />} />
        
        <Route path="contest-results/:contestId" element={<ContestResult />} />
        <Route path="*" element={<NotFoundPage />} />
        
      </Route>
        <Route path="/user/pricing/:role/:userId" element={<PricingPlan />} />
        <Route path="/artist/pricing/:role/:userId" element={<PricingPlan />} />
        <Route
        path="/user/checkout/:userId/:planId/:role"
        element={
          <Elements stripe={stripePromise}>
            <Checkout />
          </Elements>
        }
      />

    </Route>
  );
};
